<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center mt-4" [ngClass]="{'page-title': useRebrandedLayout }">
          Add {{ address.addressType ===  userAddressType.Main ? 'your main' : 'a secondary' }} address
        </h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 text-center mt-5 mb-3">
        <h5 [ngClass]="{'page-title': useRebrandedLayout }">
          To add your address, please fill in the fields below:
        </h5>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 mb-3">
        <app-address-form
          [address]="address"
          [showLoader]="loading"
          (save)="onSave()">
        </app-address-form>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a [routerLink]="['/account']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
        </a>
      </div>
    </div>
  </div>
</div>
